import React from "react";
import {
  Avatar as GSAvatar,
  AvatarFallbackText,
  AvatarImage,
} from "ui/gluestack/avatar";

type Props = {
  image?: string;
  profile?: { first_name?: string; last_name?: string };
  size?: "sm" | "md" | "lg" | "xl"; // Define possible size options
} & React.ComponentProps<typeof GSAvatar>;

export const Avatar = ({ image, profile, size, ...props }: Props) => {
  const [hasError, setHasError] = React.useState(false);
  const handleError = () => {
    setHasError(true);
  };

  return (
    <GSAvatar {...props} size={size}>
      {image && !hasError ? (
        <AvatarImage source={{ uri: image }} onError={handleError} />
      ) : profile ? (
        <AvatarFallbackText className="text-white">
          {/* eslint-disable-next-line react-native/no-raw-text */}
          {`${profile.first_name || ""} ${profile.last_name || ""}`}
        </AvatarFallbackText>
      ) : (
        // eslint-disable-next-line react-native/no-raw-text
        <AvatarFallbackText className="text-white">N A</AvatarFallbackText>
      )}
    </GSAvatar>
  );
};
